// src/App.js
import React, { useState } from "react";
import "./App.scss";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Works from "./components/Works/Works";
import About from "./components/About/About";
import Blogs from "./components/Blogs/Blogs";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Intro from "./components/About/RouteComponents/Intro";
import Experience from "./components/About/RouteComponents/Experience";
import Internships from "./components/About/RouteComponents/Internships";
import Graduation from "./components/About/RouteComponents/Graduation";
import Skill from "./components/Skill/Skill";
import Footer from "./components/Footer/Footer";
import Contact from "./components/Contact/Contact";
import ToggleButton from "./components/ToggleButton/ToggleButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub, faDev, faKaggle, faXTwitter } from "@fortawesome/free-brands-svg-icons";

function App() {
  const [darkTheme, setDarkTheme] = useState(true);

  const toggleTheme = () => {
    setDarkTheme(!darkTheme);
  };

  return (
    <div className={`app ${darkTheme ? "dark" : "light"}`}>
      <div className="sticky-header">
        <div className="header-content">
            <p className="contact__linkedin">
              <a
                href="https://www.linkedin.com/in/aquibpy/"
                rel="noopener noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faLinkedin}
                  size="2x"
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                />
              </a>
            </p>
            <p className="contact__github">
              <a
                href="https://github.com/AquibPy"
                rel="noopener noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faGithub}
                  size="2x"
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                />
              </a>
            </p>
            <p className="contact__devto">
              <a
                href="https://dev.to/aquibpy"
                rel="noopener noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faDev}
                  size="2x"
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                />
              </a>
            </p>
            <p className="contact__kaggle">
              <a
                href="https://www.kaggle.com/aquib5559"
                rel="noopener noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faKaggle}
                  size="2x"
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                />
              </a>
            </p>
            <p className="contact__twitter">
              <a
                href="https://twitter.com/AquibPy"
                rel="noopener noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faXTwitter}
                  size="2x"
                  style={{
                    color: darkTheme ? "#00ffff" : "#ff6347",
                  }}
                />
              </a>
            </p>
            <ToggleButton darkTheme={darkTheme} toggleTheme={toggleTheme} />
        </div>
        {/* Add other components you want to stick here */}
      </div>

      <div style={{ paddingTop: "60px" }}>
        {" "}
        {/* Add padding to avoid content being hidden under the sticky header */}
        <BrowserRouter>
          <Routes>
            <Route
              exact
              path="/"
              element={
                <>
                  <Header darkTheme={darkTheme} />
                  <Hero darkTheme={darkTheme} />
                  <Works darkTheme={darkTheme} />
                  <About darkTheme={darkTheme} />
                  <Blogs darkTheme={darkTheme} />
                  <Skill darkTheme={darkTheme} />
                  <Contact darkTheme={darkTheme} />
                  <Footer darkTheme={darkTheme} />
                </>
              }
            />
            <Route
              exact
              path="/about/intro"
              element={<Intro darkTheme={darkTheme} />}
            />
            <Route
              exact
              path="/about/experience"
              element={<Experience darkTheme={darkTheme} />}
            />
            <Route
              exact
              path="/about/internships"
              element={<Internships darkTheme={darkTheme} />}
            />
            <Route
              exact
              path="/about/graduation"
              element={<Graduation darkTheme={darkTheme} />}
            />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
